<template>
  <div class="feedback-requests overview">
    <div class="pl-2 d-inline-block" v-for="request in groupedFeedbackRequests" :key="request.id">
      <v-tooltip bottom>
        <v-badge
          slot="activator"
          :value="request.respondedAt !== null"
          bottom
          left
          class="feedback__badge"
          :color="request.isPositive ? 'success' : 'error'"
        >
          <v-icon slot="badge" v-if="request.isPositive" dark small>mdi-thumb-up</v-icon>
          <v-icon slot="badge" v-else dark small>mdi-thumb-down</v-icon>
          <v-avatar size="40">
            <img
              v-if="request.responder"
              :src="request.responder.avatar || '/img/missing/avatars/original.png'"
              class="feedback__avatar__image"
              :class="[
                request.isPositive === true ? 'success' : '',
                request.isPositive === false ? 'error' : '',
                { 'feedback__avatar--pending': request.respondedAt === null },
              ]"
            />
          </v-avatar>
        </v-badge>
        <span>{{ request.responder.fullName }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  created() {
    if (!this.allFeedbackRequests.length && !this.loadingFeedbackRequests) {
      this.$store.dispatch('admin/feedbackRequests/fetchAll', { id: this.$route.params.id })
    }
  },

  props: { applicationId: { type: Number, required: true } },

  computed: {
    ...mapState('admin/feedbackRequests', {
      allFeedbackRequests: 'all',
      loadingFeedbackRequests: 'loading',
    }),

    feedbackRequests() {
      return this.$store.getters['admin/feedbackRequests/forApplication'](this.applicationId)
    },

    groupedFeedbackRequests() {
      let feedbackRequests = JSON.parse(JSON.stringify(this.feedbackRequests))
      let grouped = {}

      feedbackRequests
        .sort(({ createdAt: a }, { createdAt: b }) => {
          if (new Date(a) < new Date(b)) return 1
          if (new Date(a) > new Date(b)) return -1
          return 0
        })
        .forEach(fr => {
          if (grouped[fr.responder.id]) return

          grouped[fr.responder.id] = fr
        })

      return grouped
    },
  },
}
</script>

<style lang="scss">
.feedback-requests.overview {
  .feedback__badge span {
    bottom: -7px;
    left: -5px;
  }

  .feedback__avatar--pending {
    filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale"); /* Firefox 10+, Firefox on Android */
    filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: gray; /* IE6-9 */
    -webkit-filter: grayscale(100%); /* Chrome 19+, Safari 6+, Safari 6+ iOS */
  }

  .feedback__avatar__image {
    padding: 2px;
  }
}
</style>
